import { ChevronDown, Filter } from "lucide-react";
import { type ReactNode, useState } from "react";

interface CollapsibleCardProps {
  title: string;
  children: ReactNode;
  icon?: ReactNode;
  defaultCollapsed?: boolean;
  className?: string;
  collapsed?: boolean;
  onCollapse?: (collapsed: boolean) => void;
}

function CollapsibleCard({
  title,
  children,
  icon,
  defaultCollapsed = false,
  className = "",
  collapsed,
  onCollapse,
}: CollapsibleCardProps) {
  const isControlled = collapsed !== undefined;
  const [internalCollapsed, setInternalCollapsed] = useState(defaultCollapsed);
  const effectiveCollapsed = isControlled ? collapsed : internalCollapsed;

  const handleCollapse = () => {
    if (isControlled && onCollapse) {
      onCollapse(!effectiveCollapsed);
    } else {
      setInternalCollapsed(!effectiveCollapsed);
    }
  };

  return (
    <section className={`rounded-xl border border-neutral-200 bg-white p-5 ${className}`}>
      <div className="flex items-center gap-2 mb-4 cursor-pointer" onClick={handleCollapse}>
        {icon || <Filter className="h-5 w-5 text-gray-600" />}
        <h2 className="text-base font-semibold text-gray-900">{title}</h2>
        <ChevronDown
          className={`h-4 w-4 text-gray-600 ml-auto transition-transform ${effectiveCollapsed ? "rotate-180" : ""}`}
        />
      </div>

      {!effectiveCollapsed && children}
    </section>
  );
}

export default CollapsibleCard;
